import { useMemo, useState } from "react";
import {
  getStoreTypeFallbackColors,
  getStoreTypeInitial,
} from "./StoreTypeAvatar";

interface StoreTypeImagePreviewProps {
  imageUrl?: string | null;
  name: string;
  className?: string;
}

const StoreTypeImagePreview = ({
  imageUrl,
  name,
  className = "",
}: StoreTypeImagePreviewProps) => {
  const [hasImageError, setHasImageError] = useState(false);
  const shouldShowImage = !!imageUrl && !hasImageError;
  const fallbackColors = useMemo(
    () => getStoreTypeFallbackColors({ id: name.length || 1, name }),
    [name]
  );

  if (shouldShowImage) {
    return (
      <div className={`store-type-image-preview image ${className}`.trim()}>
        <img
          src={imageUrl || ""}
          alt={name || "Store type"}
          onError={() => setHasImageError(true)}
        />
      </div>
    );
  }

  return (
    <div
      className={`store-type-image-preview fallback ${className}`.trim()}
      style={{
        backgroundColor: fallbackColors.background,
        color: fallbackColors.color,
      }}
      aria-hidden="true"
    >
      {getStoreTypeInitial(name)}
    </div>
  );
};

export default StoreTypeImagePreview;
